// extracted by mini-css-extract-plugin
export var btn = "index-module--btn--xLlEp";
export var hideBtn = "index-module--hideBtn--YD0yG index-module--btn--xLlEp";
export var hideNav = "index-module--hideNav--igyEb index-module--nav--0OUEw";
export var link = "index-module--link--jZJRG";
export var mqMinLg = "screen and (min-width: 67.625em)";
export var mqMinMd = "screen and (min-width: 48em)";
export var nav = "index-module--nav--0OUEw";
export var navBody = "index-module--navBody--WLR7k";
export var navHeader = "index-module--navHeader--MlOsg";
export var navWrap = "index-module--navWrap--1LzB6";
export var notSelected = "index-module--notSelected--CnAhu index-module--link--jZJRG";
export var red1 = "rgb(245, 13, 27)";
export var selected = "index-module--selected--xm9hu index-module--link--jZJRG";
export var showNav = "index-module--showNav--fGWdk index-module--nav--0OUEw";